var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trial-end-clock__container" }, [
    _c(
      "div",
      { staticClass: "header__wrapper" },
      [
        _c("SaasIcon", {
          staticClass: "sellsy-logo",
          attrs: { icon: "svgLogoSellsyText", width: "118", height: "28" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "trial-end-clock-content__container" }, [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/" + _vm.imgSrc + ".svg",
          width: 210,
          height: 160
        }
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "typographies-display-large content-title" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "typographies-paragraph-x-large-regular content-subtitle__wrapper"
        },
        _vm._l(_vm.subtitles, function(subtitle, index) {
          return _c("span", { key: index }, [
            _vm._v("\n                " + _vm._s(subtitle) + "\n            ")
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content__wrapper" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }